import React from 'react';
import { Card } from '../ui/Card';
import { WeeklyStats } from '../../utils/activityHelpers';
import { Target, Zap, Award } from 'lucide-react';
interface WeeklyHighlightsProps {
  stats: WeeklyStats;
}
export function WeeklyHighlights({
  stats
}: WeeklyHighlightsProps) {
  return <Card className="p-6 border-emerald-100" data-id="element-4387">
      <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-4388">
        <Zap className="w-5 h-5 text-amber-500" data-id="element-4389" />
        Deze week
      </h3>

      <div className="space-y-4" data-id="element-4390">
        <div className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4391">
          <div className="flex items-center gap-3" data-id="element-4392">
            <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center" data-id="element-4393">
              <Target className="w-5 h-5" data-id="element-4394" />
            </div>
            <span className="font-bold text-slate-700" data-id="element-4395">Vragen beantwoord</span>
          </div>
          <span className="text-xl font-black text-emerald-600" data-id="element-4396">
            {stats.totalQuestions}
          </span>
        </div>

        {stats.bestModuleId && <div className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4397">
            <div className="flex items-center gap-3" data-id="element-4398">
              <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xl" data-id="element-4399">
                {stats.bestModuleIcon}
              </div>
              <div data-id="element-4400">
                <div className="font-bold text-slate-700" data-id="element-4401">Meest geoefend</div>
                <div className="text-xs text-slate-500" data-id="element-4402">
                  {stats.bestModuleTitle}
                </div>
              </div>
            </div>
            <span className="text-xl font-black text-indigo-600" data-id="element-4403">
              {stats.bestModuleCount}x
            </span>
          </div>}
      </div>
    </Card>;
}